export default (numberOfDays: number) => {
  if (numberOfDays === 1) {
    return "dzień";
  }

  if (
    numberOfDays % 10 >= 2 &&
    numberOfDays % 10 <= 4 &&
    (numberOfDays % 100 < 10 || numberOfDays % 100 >= 20)
  ) {
    return "dni";
  }

  return "dni";
};
